// lib/access/daimonAccess.ts
//
// Who can talk to the Daimon. OPEN TO EVERY SIGNED-IN USER since 2026-10-05 (owner: 'all users
// have access to the Daimon'; it was a closed pilot list plus Fater admins). Her voice is billed to
// the caller's organisation credits (lib/daimon/billing.server.ts), so opening costs nothing unused.
// Deliberately separate from the Master agent's gate (masterAgentAccess.ts): the Daimon being open
// does not open Master's other surfaces. Face to face stays Fater-only (canUseDaimonVideo below).

type DaimonCaller = { dbUserId?: string | null; isFaterAdmin?: boolean | null; isImpersonating?: boolean | null } | null | undefined;

/** May this account talk to the Daimon? Server routes and the interface read the same answer. */
export const canAccessDaimon = (user: DaimonCaller): boolean => {
  // Only a Fater admin can impersonate, and keeps their own Daimon while doing it
  // (lib/daimon/caller.server.ts); the effective identity on screen is the impersonated user.
  if (user?.isFaterAdmin || user?.isImpersonating) return true;
  return typeof user?.dbUserId === 'string' && user.dbUserId.trim().length > 0;
};

/**
 * Face to face (the video call, components/daimon/DaimonFace.tsx) is for Fater's own people only
 * (owner, 2026-10-03): Fater admins and members of the Fater organisation, never a client pilot.
 */
export const canUseDaimonVideo = (user: { isFaterAdmin?: boolean | null; isFaterOrgMember?: boolean | null } | null | undefined): boolean =>
  Boolean(user?.isFaterAdmin || user?.isFaterOrgMember);
